import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function About() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <section className="w-full pt-20 pb-12">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <Breadcrumb items={[{ label: "关于我们" }]} />

            <div className="flex flex-col lg:flex-row gap-12 mt-8">
              <div className="lg:w-[40%]">
                <span className="inline-block px-3 py-1 border border-foreground-300 text-xs text-foreground-500 rounded-full">关于我们</span>

                <h1 className="mt-6 text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight">
                  每日吃瓜<span className="text-primary-500">黑料</span>
                </h1>
                <p className="mt-2 text-xl md:text-2xl font-heading font-light text-foreground-600 leading-tight">
                  全网爆料第一站
                </p>

                <p className="mt-8 text-foreground-700 leading-relaxed">
                  每日吃瓜黑料成立于2020年，是国内领先的娱乐八卦爆料聚合平台。我们致力于为广大网友提供最新、最全、最热门的黑料内容，涵盖网红黑料、明星八卦、社会热点等多个领域。
                </p>
                <p className="mt-4 text-foreground-700 leading-relaxed">
                  我们的团队由资深媒体人和技术专家组成，全天候7×24小时监控全网爆料动态，确保第一时间为读者推送最新大瓜。平台采用严格的信息审核机制，在保证内容时效性的同时，也注重信息的真实性和可靠性。
                </p>
                <p className="mt-4 text-foreground-700 leading-relaxed">
                  每日吃瓜黑料已累计覆盖超过50万个爆料话题，日均活跃用户突破100万。在这里，51fun、51cg、海角社区等热门平台的精华内容一网打尽，让每一个吃瓜人都能找到属于自己的快乐。
                </p>

                <div className="mt-6">
                  <span className="text-sm text-primary-500 font-medium underline cursor-pointer">
                    联系我们：hello@28i7.com
                  </span>
                </div>

                <div className="flex items-center gap-8 mt-10">
                  <div className="text-right">
                    <span className="block text-2xl md:text-3xl font-heading font-bold text-foreground-950">50万+</span>
                    <span className="text-xs text-foreground-500">覆盖爆料话题</span>
                  </div>
                  <div className="text-right">
                    <span className="block text-2xl md:text-3xl font-heading font-bold text-foreground-950">100万+</span>
                    <span className="text-xs text-foreground-500">日均活跃用户</span>
                  </div>
                </div>
              </div>

              <div className="lg:w-[60%]">
                <div className="flex gap-4">
                  <div className="w-[35%] pt-8">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20workspace%20with%20warm%20ambient%20lighting%2C%20creative%20team%20collaboration%20area%2C%20clean%20wooden%20desk%20with%20laptops%2C%20indoor%20plants%2C%20cozy%20professional%20atmosphere%2C%20editorial%20workspace%20photography%2C%20warm%20neutral%20tones&width=500&height=500&seq=about-team-01&orientation=squarish"
                      alt="每日吃瓜黑料团队"
                      className="w-full rounded-xl object-cover aspect-square"
                      title="每日吃瓜黑料 - 办公环境"
                    />
                  </div>
                  <div className="w-[60%]">
                    <img
                      src="https://readdy.ai/api/search-image?query=Diverse%20team%20of%20creative%20professionals%20brainstorming%20in%20a%20modern%20meeting%20room%2C%20casual%20atmosphere%2C%20sticky%20notes%20on%20glass%20wall%2C%20natural%20daylight%2C%20collaborative%20energy%2C%20editorial%20teamwork%20photography%2C%20warm%20authentic%20tones&width=600&height=800&seq=about-team-02&orientation=portrait"
                      alt="团队协作"
                      className="w-full rounded-xl object-cover aspect-[3/4]"
                      title="每日吃瓜黑料 - 团队协作"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-16 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="mb-12">
              <span className="inline-block px-3 py-1 border border-foreground-300 text-xs text-foreground-500 rounded-full">我们的优势</span>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mt-4 leading-tight">
                免费吃瓜
              </h2>
              <p className="text-xl md:text-3xl font-heading font-bold text-foreground-950 leading-tight">
                黑料每日更新
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              <div className="bg-background-50 rounded-xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center mb-5">
                  <i className="ri-flashlight-line text-3xl text-foreground-800"></i>
                </div>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3">实时更新</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  7×24小时全天候监控全网爆料动态，第一时间推送最新大瓜，让你永远比别人先吃到最新鲜的瓜。
                </p>
              </div>

              <div className="bg-background-50 rounded-xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center mb-5">
                  <i className="ri-spy-line text-3xl text-foreground-800"></i>
                </div>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3">独家资源</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  拥有广泛的线人网络和独家爆料渠道，为你带来别处看不到的独家内幕和深度报道。
                </p>
              </div>

              <div className="bg-background-50 rounded-xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center mb-5">
                  <i className="ri-group-line text-3xl text-foreground-800"></i>
                </div>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3">社区互动</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  千万瓜友在线讨论，评论区就是第二个瓜田。在这里不仅能吃瓜，还能和志同道合的人一起分享见解。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-0 rounded-xl overflow-hidden">
              <div className="lg:w-[60%] bg-background-50 px-6 md:px-10 py-12 md:py-16">
                <div className="flex items-center gap-2 mb-8">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-sm font-medium text-foreground-700">媒体评价</span>
                </div>

                <blockquote className="max-w-[80%]">
                  <span className="text-5xl md:text-7xl font-heading text-foreground-300 leading-none">&ldquo;</span>
                  <p className="text-xl md:text-2xl lg:text-3xl font-heading text-foreground-950 leading-snug -mt-4">
                    每日吃瓜黑料已成为中文互联网最活跃的爆料聚合平台之一，其快速的响应机制和广泛的信源网络让它在竞争激烈的八卦市场中脱颖而出。
                  </p>
                </blockquote>

                <div className="mt-8 flex items-center gap-3">
                  <span className="text-sm font-bold text-foreground-950">36氪 · 深度报道</span>
                  <span className="flex items-center gap-1 text-xs text-accent-600">
                    <i className="ri-verified-badge-fill text-accent-500"></i>
                    权威媒体
                  </span>
                </div>
              </div>

              <div className="lg:w-[40%]">
                <img
                  src="https://readdy.ai/api/search-image?query=Black%20and%20white%20portrait%20of%20a%20professional%20media%20editor%20in%20profile%2C%20dramatic%20side%20lighting%2C%20clean%20white%20background%2C%20confident%20expression%2C%20editorial%20portrait%20photography%2C%20high%20contrast%2C%20timeless%20style&width=600&height=800&seq=about-media-portrait&orientation=portrait"
                  alt="媒体编辑肖像"
                  className="w-full h-full object-cover min-h-[300px] lg:min-h-[400px]"
                  title="36氪 - 深度报道编辑"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-16 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <h2 className="text-2xl font-heading font-bold text-foreground-950 text-center mb-12">常见问题</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              <div className="bg-background-50 rounded-xl p-6">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">每日吃瓜黑料的内容来源是什么？</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们的内容来自全网公开信息、用户投稿、线人爆料等多个渠道，所有内容均经过审核团队核实后发布。
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">如何投稿爆料？</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  你可以通过网站底部的订阅爆料入口提交信息，或发送邮件至 hello@28i7.com，我们将严格保护爆料人隐私。
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">网站内容是否收费？</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  完全免费！每日吃瓜黑料所有内容永久免费，我们承诺不向用户收取任何费用，免费吃瓜是我们的宗旨。
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">如何联系每日吃瓜黑料团队？</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  商务合作、内容投诉、意见建议，请发送邮件至 hello@28i7.com，我们将在24小时内回复。
                </p>
              </div>
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@graph": [
                {
                  "@type": "AboutPage",
                  name: "关于我们 - 每日吃瓜黑料",
                  description: "每日吃瓜黑料是国内领先的娱乐八卦爆料聚合平台，致力于为广大网友提供最新最全的黑料内容。",
                  url: `${typeof window !== "undefined" ? window.location.origin : "http://28i7.com/"}/about`,
                  mainEntity: {
                    "@type": "Organization",
                    name: "每日吃瓜黑料",
                    url: "http://28i7.com/",
                    logo: `${typeof window !== "undefined" ? window.location.origin : "http://28i7.com/"}/favicon.png`,
                    description: "每日吃瓜黑料 - 每日新料吃瓜网，吃瓜中心，全网爆料第一站",
                    email: "hello@28i7.com",
                    foundingDate: "2020",
                    sameAs: ["http://28i7.com/mrcg"],
                    contactPoint: {
                      "@type": "ContactPoint",
                      email: "hello@28i7.com",
                      contactType: "customer service",
                      availableLanguage: "Chinese",
                    },
                  },
                },
                {
                  "@type": "Organization",
                  name: "每日吃瓜黑料",
                  url: "http://28i7.com/",
                  logo: `${typeof window !== "undefined" ? window.location.origin : "http://28i7.com/"}/favicon.png`,
                  description: "每日吃瓜黑料是国内领先的娱乐八卦爆料聚合平台。",
                  email: "hello@28i7.com",
                  foundingDate: "2020",
                  sameAs: ["http://28i7.com/mrcg"],
                  contactPoint: {
                    "@type": "ContactPoint",
                    email: "hello@28i7.com",
                    contactType: "customer service",
                    availableLanguage: "Chinese",
                  },
                },
              ],
            }),
          }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "每日吃瓜黑料的内容来源是什么？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "我们的内容来自全网公开信息、用户投稿、线人爆料等多个渠道，所有内容均经过审核团队核实后发布。",
                  },
                },
                {
                  "@type": "Question",
                  name: "如何投稿爆料？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "你可以通过网站底部的订阅爆料入口提交信息，或发送邮件至 hello@28i7.com，我们将严格保护爆料人隐私。",
                  },
                },
                {
                  "@type": "Question",
                  name: "网站内容是否收费？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "完全免费！每日吃瓜黑料所有内容永久免费，我们承诺不向用户收取任何费用。",
                  },
                },
                {
                  "@type": "Question",
                  name: "如何联系每日吃瓜黑料团队？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "商务合作、内容投诉、意见建议，请发送邮件至 hello@28i7.com，我们将在24小时内回复。",
                  },
                },
                {
                  "@type": "Question",
                  name: "每日吃瓜黑料是什么时候成立的？",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "每日吃瓜黑料成立于2020年，是国内领先的娱乐八卦爆料聚合平台，已累计覆盖超过50万个爆料话题。",
                  },
                },
              ],
            }),
          }}
        />
      </main>
      <Footer />
    </div>
  );
}
